
import store from './store';

let menu = [];
export const getMenu=(list) =>{
  if(sessionStorage.getItem('routers')){
    menu = JSON.parse(sessionStorage.getItem('routers'))
    store.commit('changeMenuList', menu)
  }else{
    menu = list
  }
}
let subMenu = []
export const getSubMenu=(arr) => {
  if(sessionStorage.getItem('subMenu')){
    subMenu = JSON.parse(sessionStorage.getItem('subMenu'))
  }else{
    subMenu = arr
  }
}


export {
	menu,
	subMenu
}



// WEBPACK FOOTER //
// ./src/menuData.js